<script>
import { defineComponent, ref, toRaw } from "@vue/composition-api";

export default defineComponent({
  name: "SearchForm",
  emits: ['on-search-form'],
  setup(_, { emit }) {
    const initFormState = () => ({
      emailName: "",
    });

    // 初始化表单
    const formState = ref(initFormState());

    // 重置表单
    const handleRestForm = () => {
      formState.value = initFormState();
    };

    // 查询表单
    const handleSearchForm = () => {
      emit("on-search-form", toRaw(formState));
    };

    return {
      formState,
      handleRestForm,
      handleSearchForm,
    };
  },
});
</script>

<template>
  <div class="SearchForm">
    <a-form layout="inline" :model="formState">
      <a-form-item label="邮件名称">
        <a-input v-model="formState.emailName" placeholder="请输入邮件名称" />
      </a-form-item>
      <a-form-item>
        <a-button @click="handleRestForm">重置</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearchForm">查询</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<style lang="less" scoped></style>
